import { Component, OnInit, Inject, Input } from '@angular/core';
import { IModule } from 'projects/web-user-profile/src/app/models/templates/modules/i-module';
import { ReportProfileBaseModel, UserModel, BaseProviderInstanceResourceModel, ZimbraMailingReportProfile, ZimbraReportProfileModel, AlertInvalidStateFeaturedModel, ReportProfileResourceBase } from '@i2a/web-api-client';
import { RegisterMyProfileComponent } from 'projects/web-user-profile/src/app/decorators/my-profile-component.decorator';
import { ProfileBaseClassComponent } from '../../../../shared/profile-base-class-component';
import { ToastrService } from 'ngx-toastr';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ZimbraMailingDelegate } from 'projects/web-user-profile/src/app/models/providers/zimbra/mailing/zimbra-mailing-delegate';
import { ZimbraMailingFilterRuleConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/zimbra-mailing-filter-rule-configuration';
import { TemplateConstants } from 'projects/web-user-profile/src/app/models/templates/template-constants';
import { BaseTemplate } from 'projects/web-user-profile/src/app/models/templates/base-template';

@RegisterMyProfileComponent(TemplateConstants.MODULE_ZIMBRA_MAILING_FILTER_RULE)
@Component({
  selector: 'i2a-zimbra-mailing-filter-rule-module',
  templateUrl: './zimbra-mailing-filter-rule-module.component.html',
  styleUrls: ['./zimbra-mailing-filter-rule-module.component.scss']
})
export class ZimbraMailingFilterRuleModuleComponent extends ProfileBaseClassComponent<ZimbraMailingFilterRuleConfiguration,ZimbraMailingReportProfile> implements OnInit, IModule<ZimbraMailingFilterRuleConfiguration> {
  private resource: BaseProviderInstanceResourceModel;
  public mailingProfile: ZimbraMailingReportProfile;

  @Input()
  public delegatesWithAccessAndPermissions: ZimbraMailingDelegate[];

  constructor(
    toastr: ToastrService,
    @Inject(I18NEXT_SERVICE) i18Next: ITranslationService) {
    super(toastr, i18Next, null);
  }

  ngOnInit() {
  }

  initialize(user: UserModel, profile: ReportProfileBaseModel, configuration: ZimbraMailingFilterRuleConfiguration,  alerts: AlertInvalidStateFeaturedModel[], resource: BaseProviderInstanceResourceModel, resourceTemplate?: BaseTemplate): void {
    this.baseInitialize(user, profile, configuration, alerts);
    this.resource = resource;
    this.mailingProfile = (<ZimbraReportProfileModel>profile).mailingProfiles.find(r => r.providerInstanceResource.providerInstanceResourceId == resource.providerInstanceResourceId);
  }

  alertSent(event): void {
    this.onAlertSent.emit(event);
  }

}
